document.addEventListener("DOMContentLoaded", function () {
  const input = document.getElementById("codeInput");
  const placeholder = document.querySelector(".sp_form__placeholder");
  const errorEl = document.getElementById("codeError");

  if (!input || !placeholder) return;

  // Only spans that represent code characters (skip the dash)
  const digitSlots = placeholder.querySelectorAll("span:not(.gap)");
  if (!digitSlots.length) return;

  function updateCaret() {
    const raw = input.value || "";
    // Keep only "word" chars (letters, numbers, underscore) – adjust if needed
    const digits = raw.replace(/\W/g, "").slice(0, digitSlots.length);
    const len = digits.length;

    digitSlots.forEach((span, idx) => {
      if (len === 0) {
        // caret on first slot when empty
        span.classList.toggle("active", idx === 0);
      } else {
        // caret stays on last entered character, even when all are filled
        span.classList.toggle("active", idx === len - 1);
      }
    });
  }

  function focusCodeInput() {
    input.focus();
    updateCaret();
  }

  // Normal caret behavior
  input.addEventListener("input", updateCaret);
  input.addEventListener("focus", updateCaret);

  // Clicking the visual placeholder should focus + update caret
  placeholder.addEventListener("click", focusCodeInput);

  // 1) Autofocus as soon as the First Form is shown (page load)
  focusCodeInput();

  // 2) When an incorrect code is shown (error becomes visible), refocus the input
  if (errorEl) {
    const observer = new MutationObserver(() => {
      const text = errorEl.textContent.trim();
      const style = window.getComputedStyle(errorEl);
      const visible = text.length > 0 && style.display !== "none" && style.visibility !== "hidden";

      if (visible) {
        focusCodeInput();
      }
    });

    observer.observe(errorEl, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style", "class"]
    });
  }

  // Initial caret state
  updateCaret();
});
